import { useState, useEffect } from 'react';

function useKeyPress(targetKey, el) {
  if (el === void 0) {
    el = window;
  }

  var _useState = useState(false),
      keyPressed = _useState[0],
      setKeyPressed = _useState[1];

  useEffect(function () {
    var keydownHandler = function keydownHandler(_ref) {
      var key = _ref.key;
      return key === targetKey ? setKeyPressed(true) : null;
    };

    var keyupHandler = function keyupHandler(_ref2) {
      var key = _ref2.key;
      return key === targetKey ? setKeyPressed(false) : null;
    };

    el.addEventListener("keydown", keydownHandler);
    el.addEventListener("keyup", keyupHandler);
    return function () {
      el.removeEventListener("keydown", keydownHandler);
      el.removeEventListener("keyup", keyupHandler);
    };
  }, [el, targetKey]);
  return keyPressed;
}

export { useKeyPress };